import {Component, HostListener, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {MenuService} from "../../services/menu.service";
import {Router} from "@angular/router";
import {PageService} from "../../services/page.service";
import {environment} from "../../../environments/environment";
import {InformationService} from "../../services/information.service";
import {takeUntil} from "rxjs";

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less'],
  animations: [
    trigger('expandedPanel', [
      state('initial', style({height: 0, overflow: "hidden"})),
      state('expanded', style({height: 240})),
      transition('initial <=> expanded', animate('0.1s')),
    ]),

  ],

})
export class HeaderComponent implements OnInit {
  menuActive: boolean = true;
  screenWidth: number = 0;
  isExpanded: boolean = false

  libraryOn: boolean = environment.library;
  libraryOnParam: boolean = false;
  franchiseOn: boolean = false;

  state: string = 'initial';

  constructor(
    private menuService: MenuService,
    private router: Router,
    private pageService: PageService,
    private informationService: InformationService,

  ) {
  }

  setMenuInitState() {
    this.isExpanded = false;
    this.state = 'initial';
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = event.target.innerWidth;
    this.menuActive = this.screenWidth > 650;
    this.isExpanded = false;
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.menuActive = this.screenWidth > 650;

    this.informationService.getFrontParams()
      .subscribe(
        (res: any) => {
          this.libraryOnParam =  res.results.find ((value:any) =>  value.name == 'library-on')?.value;
          this.libraryOn = this.libraryOn && this.libraryOnParam;

          this.franchiseOn =  res.results.find ((value:any) =>  value.name == 'franchise-on')?.value;
        })

    this.setMenuInitState();

    let contentElement = document.getElementById('content');
    contentElement?.addEventListener('click',  () => {this.setMenuInitState()})

    this.router.events.subscribe(() => {
      this.setMenuInitState();
    })


  }

  showMenu() {
    if (this.screenWidth < 550) {
      this.isExpanded = !this.isExpanded;
      this.state = this.isExpanded ? 'expanded' : 'initial'
    }

  }

  setBasePagePosition() {
    this.pageService.setBasePosition();
  }

  navigate($event: any) {
    this.showMenu();
    this.router.navigate([$event], {queryParams: {genre: 'all'}})
    this.pageService.setBasePosition();
  }


}
